import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projects-details-prod',
  templateUrl: './projects-details-prod.component.html',
  styleUrls: ['./projects-details-prod.component.scss']
})
export class ProjectsDetailsProdComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
